import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { parse } from 'date-fns';
import { useContext } from 'react';
import { LocaleContext, } from '@zurich/common/contexts';
import { useTranslation } from '@zurich/common/hooks';
import { Card, CardContent, CardHeader, FormGrid, Table, } from '@zurich/ui/legacy/components';
import { useAppLinkUi } from '@zurich/ui/legacy/hooks';
import { displayNullable } from '@zurich/ui/legacy/types';
function DocumentLink({ wsid, timestamp, dokTyp, title, }) {
    const AppLinkUi = useAppLinkUi();
    const id = (wsid ?? '').concat(timestamp ?? '');
    const link = `/api/document/elak/${id}?doctype=${dokTyp}`;
    return (_jsx(AppLinkUi, { href: link, target: "_blank", children: _jsx("strong", { children: title ?? `${id}.pdf` }) }));
}
export function PortalDocuments({ pageType, archiveMetadataProp, simpleView, }) {
    const { t } = useTranslation();
    const locale = useContext(LocaleContext);
    const columns = [
        {
            label: t('portal:documents.date'),
            value: (row) => row.timestamp,
            formatFunction: (row) => checkDate(row.timestamp, locale),
            width: 200,
            align: 'left',
        },
        {
            label: t('portal:documents.link'),
            value: (row) => (_jsx(DocumentLink, { ...row, title: simpleView ? documentNameUnifyier(row, t) : undefined }, "document-link")),
        },
        ...(simpleView
            ? []
            : [
                {
                    label: t('portal:documents.info'),
                    value: (row) => row.info,
                    width: 200,
                    align: 'left',
                },
            ]),
    ];
    return (_jsx(FormGrid, { rowGap: 3, children: _jsxs(Card, { children: [_jsx(CardHeader, { title: t('portal:documents.title') }), _jsx(CardContent, { children: archiveMetadataProp && archiveMetadataProp.length > 0 ? (_jsx(Table, { columns: columns, data: [...archiveMetadataProp].sort(sortDate) })) : (t('portal:documents.noDocuments', { context: pageType })) })] }) }));
}
// e.g. 211001104756 - Timestamp 21.10.01 10:47:56
// last 3 charaters are for document versioning and are
// not relevant for parsing the timestamp
const parseTimestamp = (date) => parse(date.substring(0, date.length - 3), 'yyMMddHHmmss', new Date());
const checkDate = (date, locale) => {
    const { formatDate } = locale;
    if (!date) {
        return displayNullable(null);
    }
    try {
        return formatDate(parseTimestamp(date).toISOString());
    }
    catch (err) {
        console.error(err);
        return displayNullable(null);
    }
};
const sortDate = (a, b) => {
    if (!a.timestamp) {
        return 1;
    }
    if (!b.timestamp) {
        return -1;
    }
    return (parseTimestamp(b.timestamp).getTime() -
        parseTimestamp(a.timestamp).getTime());
};
const documentNameUnifyier = ({ dokTyp, keyTyp, info }, t) => {
    const path = 'portal:documents.documentTypes';
    if ((dokTyp === 'POL' && keyTyp === 'V' && info === 'Letztstandspolizze') ||
        (dokTyp === 'POL' && keyTyp === 'V' && info === 'Korrespondenz')) {
        return t(`${path}.policy`);
    }
    if ((dokTyp === 'SAK' && keyTyp === 'V' && info === 'ELU') ||
        (dokTyp === 'LAK' && keyTyp === 'V' && info === 'ELU')) {
        return t(`${path}.applicationDocuments`);
    }
    if (dokTyp === 'IDX' && keyTyp === 'V' && info === 'Indexerhöhung') {
        return t(`${path}.indexIncrease`);
    }
    if (dokTyp === 'IDX' && keyTyp === 'V' && info === 'Tarifanpassung') {
        return t(`${path}.tariffAdjustment`);
    }
    if (dokTyp === 'IVK' && keyTyp === 'V') {
        return t(`${path}.internationalInsuranceCard`);
    }
    if (dokTyp === 'POL' && keyTyp === 'V' && info === 'Storno') {
        return t(`${path}.stornoConfirmation`);
    }
    if (dokTyp === 'IDX' && keyTyp === 'V' && info === 'Korrespondenz') {
        return t(`${path}.indexIncrease`);
    }
};
